import { db } from './index'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'

/**
 * 관심고객 등록
 * @param {Object} customerData - 고객 정보
 * @param {string} customerData.name - 이름
 * @param {string} customerData.phone - 연락처
 * @returns {Promise<string>} - 등록된 문서 ID
 */
export async function registerCustomer(customerData) {
  const docRef = await addDoc(collection(db, 'customers'), {
    name: customerData.name,
    phone: customerData.phone,
    visitDate: customerData.visitDate || '',
    source: customerData.source || 'website',
    status: 'new',
    createdAt: serverTimestamp()
  })
  return docRef.id
}
